import { render, staticRenderFns } from "./edit-section.component.vue?vue&type=template&id=d613fa78&scoped=true"
import script from "./edit-section.component.vue?vue&type=script&lang=js"
export * from "./edit-section.component.vue?vue&type=script&lang=js"
import style0 from "./edit-section.component.vue?vue&type=style&index=0&id=d613fa78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d613fa78",
  null
  
)

export default component.exports